import { render, staticRenderFns } from "./permissionDialog.vue?vue&type=template&id=a89920a4&scoped=true"
import script from "./permissionDialog.vue?vue&type=script&lang=ts"
export * from "./permissionDialog.vue?vue&type=script&lang=ts"
import style0 from "./permissionDialog.vue?vue&type=style&index=0&id=a89920a4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89920a4",
  null
  
)

export default component.exports